import React, { FC, memo, useEffect } from 'react';
import Timer from './Timer';
import useIntervention from 'src/hooks/api/useIntervention';
import Intervention, { AddInterventionOptions } from 'src/interfaces/api/Intervention';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import interventionsState, { InterventionState } from 'src/recoil/atoms/ticketInterventions';
import { ticketInterventionsState } from 'src/recoil/selectors/ticketInterventions';
import Ticket from 'src/interfaces/api/Ticket';

interface Props {
  ticketId: Ticket['id'];
}

const TimerContainer: FC<Props> = ({ ticketId }) => {
  const { create: createIntervention } = useIntervention();
  const interventions = useRecoilValue(ticketInterventionsState(ticketId));
  const setInterventions = useSetRecoilState(interventionsState);
  const { getTicketInterventions } = useIntervention();

  const fetchTicketInterventions = async () => {
    const collection = await getTicketInterventions(ticketId);
    const newInterventions: Record<Intervention['id'], InterventionState>[] = collection.items.map(
      (intervention: Intervention) => ({
        [intervention.id]: {
          ...intervention,
          ticketId,
        },
      })
    );

    setInterventions((interventions) => Object.assign({}, interventions, ...newInterventions));
  };

  useEffect(() => {
    fetchTicketInterventions();
  }, []);

  const handleCreateIntervention = async (addInterventionOptions: AddInterventionOptions) => {
    const intervention = await createIntervention(ticketId, addInterventionOptions);

    setInterventions((interventions) =>
      Object.assign({}, interventions, { [intervention.id]: { ...intervention, ticketId } })
    );
  };

  return <Timer interventions={interventions} onCreateIntervention={handleCreateIntervention} />;
};

export default memo(TimerContainer, (prevProps, nextProps) => prevProps.ticketId === nextProps.ticketId);
